module.exports = __webpack_public_path__ + "static/img/quick-answer-count.08629dea.png";